// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConceptList_concept-list__TQIxW {
  padding: 0;
  background-color: #ffffff;
  min-height: 100vh;
}
@media (max-width: 1200px) {
  .ConceptList_concept-list__TQIxW {
    padding: 24px 0;
  }
}
.ConceptList_concept-list__TQIxW .ConceptList_sectionTitle__hjSiV {
  font-size: 48px;
  color: #2c3e50;
  margin-bottom: 24px;
  text-align: center;
  font-weight: 800;
  letter-spacing: -1px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}
@media (max-width: 1200px) {
  .ConceptList_concept-list__TQIxW .ConceptList_sectionTitle__hjSiV {
    font-size: 36px;
  }
}
.ConceptList_concept-list__TQIxW .ConceptList_sectionDescription__uTd0d {
  font-size: 20px;
  color: #34495e;
  max-width: 800px;
  margin: 0 auto 48px;
  text-align: center;
  line-height: 1.6;
}
@media (max-width: 1200px) {
  .ConceptList_concept-list__TQIxW .ConceptList_sectionDescription__uTd0d {
    font-size: 18px;
    margin-bottom: 36px;
  }
}
.ConceptList_concept-list__TQIxW .ConceptList_featuredSectionWrapper__GRdA2 {
  width: 100%;
  margin: 64px 0 80px;
  background-color: transparent;
}
@media (max-width: 1200px) {
  .ConceptList_concept-list__TQIxW .ConceptList_featuredSectionWrapper__GRdA2 {
    margin: 32px 0 64px;
  }
}
.ConceptList_concept-list__TQIxW .ConceptList_featuredSection__0JL9w {
  width: 100%;
  max-width: none;
  position: relative;
  overflow: visible;
}
@media (max-width: 1200px) {
  .ConceptList_concept-list__TQIxW .ConceptList_featuredSection__0JL9w {
    padding: 0 16px;
  }
}
.ConceptList_concept-list__TQIxW .ConceptList_conceptTabs__hzMHJ {
  position: relative;
  z-index: 1;
  margin-bottom: 24px;
}
.ConceptList_concept-list__TQIxW .ConceptList_conceptTabs__hzMHJ .ant-tabs-nav::before {
  display: none;
}
.ConceptList_concept-list__TQIxW .ConceptList_conceptTabs__hzMHJ .ant-tabs-nav-list {
  background: transparent;
  border-radius: 0;
  padding: 0;
  display: flex;
  justify-content: center;
}
.ConceptList_concept-list__TQIxW .ConceptList_conceptTabs__hzMHJ .ant-tabs-tab {
  font-size: 16px;
  padding: 8px 16px;
  transition: all 0.3s ease;
  border-radius: 4px;
  margin: 0 8px;
  background: transparent;
  border: none;
  color: rgba(0, 0, 0, 0.65);
}
.ConceptList_concept-list__TQIxW .ConceptList_conceptTabs__hzMHJ .ant-tabs-tab .ConceptList_anticon__AvnaU,
.ConceptList_concept-list__TQIxW .ConceptList_conceptTabs__hzMHJ .ant-tabs-tab svg {
  margin-right: 8px;
  vertical-align: middle;
}
.ConceptList_concept-list__TQIxW .ConceptList_conceptTabs__hzMHJ .ant-tabs-tab-active {
  font-weight: 600;
  background: transparent;
  box-shadow: none;
}
.ConceptList_concept-list__TQIxW .ConceptList_conceptTabs__hzMHJ .ant-tabs-tab-active::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 20px;
  height: 2px;
}
.ConceptList_concept-list__TQIxW .ConceptList_conceptTabs__hzMHJ .ant-tabs-ink-bar {
  display: none;
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselWrapper__VKlKS {
  margin: 20px -24px;
  padding: 20px 0 80px;
  position: relative;
  will-change: transform;
}
@media (max-width: 1200px) {
  .ConceptList_concept-list__TQIxW .ConceptList_carouselWrapper__VKlKS {
    margin: 30px -16px;
    padding: 20px 40px 0;
  }
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselWrapper__VKlKS .ant-carousel {
  margin-bottom: 20px;
}
@media (max-width: 2560px) {
  .ConceptList_concept-list__TQIxW .ConceptList_carouselWrapper__VKlKS .ant-carousel .slick-slider .slick-list {
    height: 550px;
  }
}
@media only screen and (max-width: 1200px) {
  .ConceptList_concept-list__TQIxW .ConceptList_carouselWrapper__VKlKS .ant-carousel .slick-slider .slick-list {
    height: 550px;
  }
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselWrapper__VKlKS .ant-carousel .slick-slide {
  padding: 0 10px;
  opacity: 0.5;
  transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1), transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselWrapper__VKlKS .ant-carousel .slick-slide.slick-active {
  opacity: 1;
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselWrapper__VKlKS .ant-carousel .slick-slide.slick-active.slick-current {
  transform: scale(1.05);
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselWrapper__VKlKS .ant-carousel .slick-dots {
  bottom: -40px;
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselWrapper__VKlKS .ant-carousel .slick-dots li button {
  background-color: rgba(52, 152, 219, 0.3);
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselWrapper__VKlKS .ant-carousel .slick-dots li.slick-active button {
  background: linear-gradient(90deg, rgba(142, 68, 173, 0.8), rgba(52, 152, 219, 0.8));
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselWrapper__VKlKS .ant-carousel .slick-prev,
.ConceptList_concept-list__TQIxW .ConceptList_carouselWrapper__VKlKS .ant-carousel .slick-next {
  z-index: 1;
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, rgba(142, 68, 173, 0.1), rgba(52, 152, 219, 0.1));
  border-radius: 50%;
  transition: all 0.3s ease;
  opacity: 0.7;
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselWrapper__VKlKS .ant-carousel .slick-prev:hover, .ConceptList_concept-list__TQIxW .ConceptList_carouselWrapper__VKlKS .ant-carousel .slick-prev:focus,
.ConceptList_concept-list__TQIxW .ConceptList_carouselWrapper__VKlKS .ant-carousel .slick-next:hover,
.ConceptList_concept-list__TQIxW .ConceptList_carouselWrapper__VKlKS .ant-carousel .slick-next:focus {
  background: linear-gradient(135deg, rgba(142, 68, 173, 0.2), rgba(52, 152, 219, 0.2));
  opacity: 1;
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselWrapper__VKlKS .ant-carousel .slick-prev::before,
.ConceptList_concept-list__TQIxW .ConceptList_carouselWrapper__VKlKS .ant-carousel .slick-next::before {
  content: "";
  width: 10px;
  height: 10px;
  border-top: 2px solid rgba(52, 152, 219, 0.8);
  border-right: 2px solid rgba(52, 152, 219, 0.8);
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transition: all 0.3s ease;
  color: transparent;
  font-size: 0;
  line-height: 0;
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselWrapper__VKlKS .ant-carousel .slick-prev::after,
.ConceptList_concept-list__TQIxW .ConceptList_carouselWrapper__VKlKS .ant-carousel .slick-next::after {
  display: none;
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselWrapper__VKlKS .ant-carousel .slick-prev:hover::before,
.ConceptList_concept-list__TQIxW .ConceptList_carouselWrapper__VKlKS .ant-carousel .slick-next:hover::before {
  border-top: 2px solid rgba(142, 68, 173, 0.8);
  border-right: 2px solid rgba(142, 68, 173, 0.8);
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselWrapper__VKlKS .ant-carousel .slick-prev {
  left: -5px;
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselWrapper__VKlKS .ant-carousel .slick-prev::before {
  transform: translate(-25%, -50%) rotate(-135deg);
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselWrapper__VKlKS .ant-carousel .slick-next {
  right: -5px;
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselWrapper__VKlKS .ant-carousel .slick-next::before {
  transform: translate(-75%, -50%) rotate(45deg);
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselSlide__psVEW {
  height: 100%;
  padding: 20px 0;
  will-change: transform;
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 {
  background: linear-gradient(135deg, #fafbff 0%, #f8f9ff 100%);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  min-height: 350px;
  max-height: 500px;
  display: flex;
  flex-direction: column;
  padding: 20px;
  max-width: 95%;
  margin: 0 auto;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  will-change: transform, box-shadow;
  border: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;
  z-index: 1;
}
@media (max-width: 1200px) {
  .ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 {
    padding: 16px;
  }
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 .ConceptList_ant-card__kDN5n:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 .ConceptList_ant-card__kDN5n:hover::before {
  opacity: 1;
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 .ConceptList_cardContent__UQNGt {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 .ConceptList_header__0BWqy {
  margin-bottom: 16px;
  position: relative;
  padding-bottom: 16px;
  text-align: center;
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 .ConceptList_header__0BWqy::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 3px;
  background: linear-gradient(90deg, #8e44ad 0%, #3498db 100%);
  border-radius: 2px;
}
@media (max-width: 1200px) {
  .ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 .ConceptList_header__0BWqy {
    margin-bottom: 12px;
    padding-bottom: 12px;
  }
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 .ConceptList_title__vhXhx {
  font-size: 24px;
  font-weight: 700;
  background: linear-gradient(90deg, #8e44ad 0%, #3498db 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
  margin-bottom: 8px;
}
@media (max-width: 1200px) {
  .ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 .ConceptList_title__vhXhx {
    font-size: 20px;
  }
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 .ConceptList_conceptDefinition__aVrPK {
  margin-bottom: 16px;
  font-size: 14px;
  line-height: 1.4;
  color: #34495e;
  text-align: left;
  max-height: 60px;
  overflow: hidden;
}
@media (max-width: 1200px) {
  .ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 .ConceptList_conceptDefinition__aVrPK {
    font-size: 12px;
    margin-bottom: 12px;
  }
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 .ConceptList_chartWrapper__FMkrX {
  flex-grow: 1;
  min-height: 120px;
  margin-top: 16px;
  margin-bottom: 16px;
  width: 100%;
}
@media (max-width: 1200px) {
  .ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 .ConceptList_chartWrapper__FMkrX {
    min-height: 100px;
    margin-top: 12px;
    margin-bottom: 12px;
  }
}
@media (min-width: 768px) and (max-width: 1199px) {
  .ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 .ConceptList_chartWrapper__FMkrX {
    min-height: 150px;
  }
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 .ConceptList_chartWrapper__FMkrX .ConceptList_customTooltip__jNYFa {
  background-color: rgba(255, 255, 255, 0.9);
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 .ConceptList_chartWrapper__FMkrX .ConceptList_customTooltip__jNYFa .ConceptList_label__e1qDF {
  font-weight: bold;
  margin-bottom: 5px;
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 .ConceptList_chartWrapper__FMkrX .ConceptList_customTooltip__jNYFa .ConceptList_data__3I\\+Rd {
  margin: 0;
  font-size: 12px;
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 .ConceptList_chartWrapper__FMkrX .recharts-legend-wrapper {
  font-size: 12px;
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 .ConceptList_chartWrapper__FMkrX .recharts-legend-wrapper .ConceptList_recharts-legend-item__zG5n4 {
  padding-right: 10px;
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 .ConceptList_conceptStats__fU12B {
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (max-width: 1200px) {
  .ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 .ConceptList_conceptStats__fU12B {
    margin-bottom: 12px;
  }
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 .ConceptList_conceptStats__fU12B .ConceptList_statWrapper__p57Vh {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 0 16px;
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 .ConceptList_conceptStats__fU12B .ConceptList_statWrapper__p57Vh .ConceptList_statContent__mEqHM {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 .ConceptList_conceptStats__fU12B .ConceptList_statWrapper__p57Vh svg {
  color: inherit;
  margin-right: 8px;
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 .ConceptList_conceptStats__fU12B .ConceptList_statWrapper__p57Vh .ConceptList_statValue__QvLM5 {
  font-size: 18px;
  color: inherit;
}
@media only screen and (max-width: 480px) {
  .ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 .ConceptList_conceptStats__fU12B .ConceptList_statWrapper__p57Vh .ConceptList_statValue__QvLM5 {
    font-size: 14px;
  }
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 .ConceptList_conceptStats__fU12B .ConceptList_statWrapper__p57Vh .ConceptList_statTitle__KC4bL {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(52, 152, 219, 0.9);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 14px;
  opacity: 0;
  transition: opacity 0.3s ease;
  white-space: nowrap;
  pointer-events: none;
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 .ConceptList_conceptStats__fU12B .ConceptList_statWrapper__p57Vh:hover .ConceptList_statTitle__KC4bL {
  opacity: 1;
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 .ConceptList_cardFooter__RtQ5Q {
  margin-top: 16px;
  text-align: right;
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 .ConceptList_viewMoreButton__bxHur {
  background: transparent;
  color: #3498db;
  padding: 8px 0;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.3s ease;
  border: none;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 .ConceptList_viewMoreButton__bxHur:hover {
  color: #2980b9;
  text-decoration: underline;
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 .ConceptList_viewMoreButton__bxHur .ConceptList_lucide__GcDI9 {
  margin-left: 8px;
  transition: transform 0.3s ease;
}
.ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 .ConceptList_viewMoreButton__bxHur:hover .ConceptList_lucide__GcDI9 {
  transform: translateX(2px);
}
@media (max-width: 1200px) {
  .ConceptList_concept-list__TQIxW .ConceptList_carouselItem__Lopn6 .ConceptList_viewMoreButton__bxHur {
    font-size: 14px;
  }
}
.ConceptList_concept-list__TQIxW .ConceptList_explorationSection__ucnoj {
  background-color: #ffffff;
  padding: 0 0 40px;
  position: relative;
  overflow: hidden;
}
@media (max-width: 1200px) {
  .ConceptList_concept-list__TQIxW .ConceptList_explorationSection__ucnoj {
    padding: 0 0 30px;
  }
}
.ConceptList_concept-list__TQIxW .ConceptList_explorationSection__ucnoj .ConceptList_explorationContent__aoH\\+V {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
@media (max-width: 1200px) {
  .ConceptList_concept-list__TQIxW .ConceptList_explorationSection__ucnoj .ConceptList_explorationContent__aoH\\+V {
    padding: 0 24px;
  }
}
.ConceptList_concept-list__TQIxW .ConceptList_explorationSection__ucnoj .ConceptList_sectionTitle__hjSiV {
  font-size: 40px;
  color: #2c3e50;
  margin-bottom: 12px;
  text-align: center;
  font-weight: 800;
  letter-spacing: -1px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}
@media (max-width: 1200px) {
  .ConceptList_concept-list__TQIxW .ConceptList_explorationSection__ucnoj .ConceptList_sectionTitle__hjSiV {
    font-size: 32px;
  }
}
.ConceptList_concept-list__TQIxW .ConceptList_explorationSection__ucnoj .ConceptList_sectionDescription__uTd0d {
  font-size: 18px;
  color: #34495e;
  max-width: 800px;
  margin: 0 auto 32px;
  text-align: center;
  line-height: 1.6;
}
@media (max-width: 1200px) {
  .ConceptList_concept-list__TQIxW .ConceptList_explorationSection__ucnoj .ConceptList_sectionDescription__uTd0d {
    font-size: 16px;
    margin-bottom: 24px;
  }
}
.ConceptList_concept-list__TQIxW .ConceptList_explorationSection__ucnoj .ConceptList_searchSection__sCQ72 {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
@media (max-width: 1200px) {
  .ConceptList_concept-list__TQIxW .ConceptList_explorationSection__ucnoj .ConceptList_searchSection__sCQ72 {
    margin-bottom: 24px;
  }
}
.ConceptList_concept-list__TQIxW .ConceptList_explorationSection__ucnoj .ConceptList_searchWrapper__iv8Y9 {
  width: 100%;
  margin-bottom: 24px;
}
.ConceptList_concept-list__TQIxW .ConceptList_explorationSection__ucnoj .ConceptList_searchWrapper__iv8Y9 .ant-input-affix-wrapper {
  width: 100%;
  border-radius: 8px;
  border: 2px solid #e8e8e8;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.ConceptList_concept-list__TQIxW .ConceptList_explorationSection__ucnoj .ConceptList_searchWrapper__iv8Y9 .ant-input-affix-wrapper:hover, .ConceptList_concept-list__TQIxW .ConceptList_explorationSection__ucnoj .ConceptList_searchWrapper__iv8Y9 .ant-input-affix-wrapper:focus-within {
  border-color: #3498db;
  box-shadow: 0 6px 12px rgba(52, 152, 219, 0.2);
}
.ConceptList_concept-list__TQIxW .ConceptList_explorationSection__ucnoj .ConceptList_searchWrapper__iv8Y9 .ant-input-affix-wrapper input {
  font-size: 16px;
  padding: 12px 16px;
}
.ConceptList_concept-list__TQIxW .ConceptList_explorationSection__ucnoj .ConceptList_searchWrapper__iv8Y9 .ant-input-prefix,
.ConceptList_concept-list__TQIxW .ConceptList_explorationSection__ucnoj .ConceptList_searchWrapper__iv8Y9 .ant-input-suffix {
  color: #3498db;
}
.ConceptList_concept-list__TQIxW .ConceptList_explorationSection__ucnoj .ConceptList_searchHint__vnvkB {
  font-size: 14px;
  color: #7f8c8d;
  text-align: center;
  font-style: italic;
  margin-bottom: 12px;
}
.ConceptList_concept-list__TQIxW .ConceptList_explorationSection__ucnoj .ConceptList_filterTags__kqam5 {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  margin-bottom: 24px;
}
.ConceptList_concept-list__TQIxW .ConceptList_explorationSection__ucnoj .ConceptList_filterTags__kqam5 .ConceptList_queryTag__rH3rg {
  background-color: rgba(204, 0, 88, 0.1);
  border: 1px solid rgba(255, 84, 156, 0.3);
  color: rgb(204, 0, 88);
  font-size: 14px;
  padding: 6px 12px;
  margin: 4px;
  display: flex;
  align-items: center;
  transition: all 0.3s;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(204, 0, 88, 0.1);
}
.ConceptList_concept-list__TQIxW .ConceptList_explorationSection__ucnoj .ConceptList_filterTags__kqam5 .ConceptList_queryTag__rH3rg:hover {
  background-color: rgba(204, 0, 88, 0.2);
  box-shadow: 0 4px 8px rgba(204, 0, 88, 0.15);
}
.ConceptList_concept-list__TQIxW .ConceptList_explorationSection__ucnoj .ConceptList_filterTags__kqam5 .ConceptList_queryTag__rH3rg .anticon {
  color: rgb(204, 0, 88);
  font-size: 12px;
  margin-left: 6px;
  cursor: pointer;
  transition: all 0.3s;
}
.ConceptList_concept-list__TQIxW .ConceptList_explorationSection__ucnoj .ConceptList_filterTags__kqam5 .ConceptList_queryTag__rH3rg .anticon:hover {
  color: rgb(255, 84, 156);
}
.ConceptList_concept-list__TQIxW .ConceptList_explorationSection__ucnoj .ConceptList_conceptGrid__yhhSW {
  width: 100%;
  margin-top: 24px;
}
.ConceptList_concept-list__TQIxW .ConceptList_explorationSection__ucnoj .ConceptList_paginationWrapper__vYVjy {
  margin-top: 32px;
  display: flex;
  justify-content: center;
}
.ConceptList_concept-list__TQIxW .ConceptList_sectionDivider__LxVcv {
  margin: 0 auto 80px;
  width: 80%;
  max-width: 1200px;
  border: none;
  height: 2px;
  background-image: linear-gradient(to right, transparent, rgba(142, 68, 173, 0.2), rgba(52, 152, 219, 0.2), rgba(204, 0, 88, 0.2), rgba(255, 84, 156, 0.2), transparent);
  position: relative;
  overflow: visible;
}
.ConceptList_concept-list__TQIxW .ConceptList_floatButtonGroup__UvyOa .ant-float-btn-group {
  width: 60px;
  height: 60px;
}
.ConceptList_concept-list__TQIxW .ConceptList_floatButtonGroup__UvyOa .ant-float-btn-group .ant-float-btn {
  background-color: #ffffff;
  border: 1px solid rgba(204, 0, 88, 0.2);
  box-shadow: 0 2px 8px rgba(204, 0, 88, 0.15);
  transition: all 0.3s;
}
.ConceptList_concept-list__TQIxW .ConceptList_floatButtonGroup__UvyOa .ant-float-btn-group .ant-float-btn:hover {
  background-color: rgba(204, 0, 88, 0.1);
  transform: translateY(-2px);
}
.ConceptList_concept-list__TQIxW .ConceptList_floatButtonGroup__UvyOa .ant-float-btn-group .ant-float-btn .ant-float-btn-body {
  width: 100%;
  height: 100%;
  background-color: transparent;
  border: none;
  box-shadow: none;
}
.ConceptList_concept-list__TQIxW .ConceptList_floatButtonGroup__UvyOa .ant-float-btn-group .ant-float-btn .ant-float-btn-body .ant-float-btn-content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(204, 0, 88);
}
.ConceptList_concept-list__TQIxW .ConceptList_floatButtonGroup__UvyOa .ant-float-btn-default {
  background-color: #ffffff;
}
.ConceptList_concept-list__TQIxW .ConceptList_floatButtonGroup__UvyOa .ant-float-btn-default .ant-float-btn-body {
  background-color: transparent;
}
.ConceptList_concept-list__TQIxW .ConceptList_floatButtonGroup__UvyOa .ant-float-btn-default .ant-float-btn-body .ant-float-btn-content {
  color: rgb(204, 0, 88);
}
.ConceptList_concept-list__TQIxW .ConceptList_floatButtonGroup__UvyOa .ant-float-btn-default:hover {
  background-color: rgba(204, 0, 88, 0.1);
}
.ConceptList_concept-list__TQIxW .ConceptList_floatButtonGroup__UvyOa .ant-float-btn-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.ConceptList_concept-list__TQIxW .ConceptList_floatButtonGroup__UvyOa .ConceptList_floatButton__JuyOF {
  margin-bottom: 16px;
  margin-right: 16px;
  transition: all 0.3s;
}
.ConceptList_concept-list__TQIxW .ConceptList_floatButtonGroup__UvyOa .ConceptList_floatButton__JuyOF:hover {
  transform: scale(1.1);
}
.ConceptList_concept-list__TQIxW .ConceptList_floatButtonGroup__UvyOa .ConceptList_floatButton__JuyOF .ant-float-btn-body {
  background-color: transparent;
}
.ConceptList_concept-list__TQIxW .ant-tooltip .ConceptList_ant-tooltip-inner__I67S3 {
  background-color: rgba(204, 0, 88, 0.9);
  color: #ffffff;
  font-size: 14px;
  padding: 6px 12px;
  border-radius: 4px;
}
.ConceptList_concept-list__TQIxW .ant-tooltip .ConceptList_ant-tooltip-arrow-content__VT5sz {
  background-color: rgba(204, 0, 88, 0.9);
}

@media (min-width: 1600px) {
  .ConceptList_concept-list__TQIxW .ConceptList_explorationSection__ucnoj .ConceptList_explorationContent__aoH\\+V {
    max-width: 1800px;
  }
}
@media (min-width: 2560px) {
  .ConceptList_concept-list__TQIxW .ConceptList_explorationSection__ucnoj .ConceptList_explorationContent__aoH\\+V {
    max-width: 2400px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/ConceptList/ConceptList.module.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,yBAAA;EACA,iBAAA;AACF;AACE;EALF;IAMI,eAAA;EAEF;AACF;AAAE;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,2CAAA;AAEJ;AAAI;EATF;IAUI,eAAA;EAGJ;AACF;AAAE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAEJ;AAAI;EARF;IASI,eAAA;IACA,mBAAA;EAGJ;AACF;AAAE;EACE,WAAA;EACA,mBAAA;EACA,6BAAA;AAEJ;AAAI;EALF;IAMI,mBAAA;EAGJ;AACF;AAAE;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AAEJ;AAAI;EANF;IAOI,eAAA;EAGJ;AACF;AAAE;EACE,kBAAA;EACA,UAAA;EACA,mBAAA;AAEJ;AACM;EACE,aAAA;AACR;AAGI;EACE,uBAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;AADN;AAII;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,0BAAA;AAFN;AAIM;;EAEE,iBAAA;EACA,sBAAA;AAFR;AAMI;EACE,gBAAA;EACA,uBAAA;EACA,gBAAA;AAJN;AAMM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;AAJR;AAQI;EACE,aAAA;AANN;AAUE;EACE,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,sBAAA;AARJ;AAUI;EANF;IAOI,kBAAA;IACA,oBAAA;EAPJ;AACF;AAUM;EACE,mBAAA;AARR;AAYY;EADF;IAEI,aAAA;EATZ;AACF;AAWY;EALF;IAMI,aAAA;EARZ;AACF;AAYQ;EACE,eAAA;EACA,YAAA;EACA,kGAAA;EAEA,+BAAA;AAXV;AAaU;EACE,UAAA;AAXZ;AAaY;EACE,sBAAA;AAXd;AAgBQ;EACE,aAAA;AAdV;AAiBY;EACE,yCAAA;AAfd;AAkBY;EACE,oFAAA;AAhBd;AAyBQ;;EAEE,UAAA;EACA,WAAA;EACA,YAAA;EACA,qFAAA;EAKA,kBAAA;EACA,yBAAA;EACA,YAAA;AA3BV;AA6BU;;;EAEE,qFAAA;EAKA,UAAA;AA9BZ;AAiCU;;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,6CAAA;EACA,+CAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AA9BZ;AAiCU;;EACE,aAAA;AA9BZ;AAiCU;;EACE,6CAAA;EACA,+CAAA;AA9BZ;AAkCQ;EACE,UAAA;AAhCV;AAiCU;EACE,gDAAA;AA/BZ;AAmCQ;EACE,WAAA;AAjCV;AAkCU;EACE,8CAAA;AAhCZ;AAuCE;EACE,YAAA;EACA,eAAA;EACA,sBAAA;AArCJ;AAwCE;EACE,6DAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,cAAA;EACA,cAAA;EACA,iDAAA;EACA,kCAAA;EACA,0CAAA;EACA,kBAAA;EACA,UAAA;AAtCJ;AAwCI;EAlBF;IAmBI,aAAA;EArCJ;AACF;AAwCM;EACE,2BAAA;EACA,2CAAA;AAtCR;AAwCQ;EACE,UAAA;AAtCV;AA2CI;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAzCN;AA4CI;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;AA1CN;AA4CM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;EACA,4DAAA;EACA,kBAAA;AA1CR;AA6CM;EAlBF;IAmBI,mBAAA;IACA,oBAAA;EA1CN;AACF;AA6CI;EACE,eAAA;EACA,gBAAA;EACA,4DAAA;EACA,6BAAA;EACA,qBAAA;EACA,oCAAA;EACA,2CAAA;EACA,kBAAA;AA3CN;AA6CM;EAVF;IAWI,eAAA;EA1CN;AACF;AA6CI;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AA3CN;AA6CM;EATF;IAUI,eAAA;IACA,mBAAA;EA1CN;AACF;AA6CI;EACE,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AA3CN;AA6CM;EAPF;IAQI,iBAAA;IACA,gBAAA;IACA,mBAAA;EA1CN;AACF;AA4CM;EAbF;IAcI,iBAAA;EAzCN;AACF;AA2CM;EACE,0CAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;AAzCR;AA2CQ;EACE,iBAAA;EACA,kBAAA;AAzCV;AA4CQ;EACE,SAAA;EACA,eAAA;AA1CV;AA8CM;EACE,eAAA;AA5CR;AA8CQ;EACE,mBAAA;AA5CV;AAiDI;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA/CN;AAiDM;EANF;IAOI,mBAAA;EA9CN;AACF;AAgDM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;AA9CR;AAgDQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AA9CV;AAiDQ;EACE,cAAA;EACA,iBAAA;AA/CV;AAkDQ;EACE,eAAA;EACA,cAAA;AAhDV;AAkDU;EAJF;IAKI,eAAA;EA/CV;AACF;AAkDQ;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,yCAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,6BAAA;EACA,mBAAA;EACA,oBAAA;AAhDV;AAmDQ;EACE,UAAA;AAjDV;AAsDI;EACE,gBAAA;EACA,iBAAA;AApDN;AAuDI;EACE,uBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AArDN;AAuDM;EACE,cAAA;EACA,0BAAA;AArDR;AAwDM;EACE,gBAAA;EACA,+BAAA;AAtDR;AAyDM;EACE,0BAAA;AAvDR;AA0DM;EA3BF;IA4BI,eAAA;EAvDN;AACF;AA2DE;EACE,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAzDJ;AA2DI;EANF;IAOI,iBAAA;EAxDJ;AACF;AA0DI;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAxDN;AA0DM;EARF;IASI,eAAA;EAvDN;AACF;AA0DI;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,2CAAA;AAxDN;AA0DM;EATF;IAUI,eAAA;EAvDN;AACF;AA0DI;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAxDN;AA0DM;EARF;IASI,eAAA;IACA,mBAAA;EAvDN;AACF;AA0DI;EACE,WAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAxDN;AA0DM;EARF;IASI,mBAAA;EAvDN;AACF;AA0DI;EACE,WAAA;EACA,mBAAA;AAxDN;AA0DM;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,wCAAA;AAxDR;AA0DQ;EAEE,qBAAA;EACA,8CAAA;AAzDV;AA4DQ;EACE,eAAA;EACA,kBAAA;AA1DV;AA8DM;;EAEE,cAAA;AA5DR;AAgEI;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AA9DN;AAiEI;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;AA/DN;AAiEM;EACE,uCAAA;EACA,yCAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,2CAAA;AA/DR;AAiEQ;EACE,uCAAA;EACA,4CAAA;AA/DV;AAkEQ;EACE,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AAhEV;AAkEU;EACE,wBAAA;AAhEZ;AAsEI;EACE,WAAA;EACA,gBAAA;AApEN;AAuEI;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;AArEN;AAyEE;EACE,mBAAA;EACA,UAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,uKAAA;EASA,kBAAA;EACA,iBAAA;AA/EJ;AAoFM;EACE,WAAA;EACA,YAAA;AAlFR;AAmFQ;EACE,yBAAA;EACA,uCAAA;EACA,4CAAA;EACA,oBAAA;AAjFV;AAmFU;EACE,uCAAA;EACA,2BAAA;AAjFZ;AAoFU;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,YAAA;EACA,gBAAA;AAlFZ;AAoFY;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AAlFd;AAwFM;EACE,yBAAA;AAtFR;AAwFQ;EACE,6BAAA;AAtFV;AAwFU;EACE,sBAAA;AAtFZ;AA0FQ;EACE,uCAAA;AAxFV;AA6FI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AA3FN;AA8FI;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AA5FN;AA8FM;EACE,qBAAA;AA5FR;AA+FM;EACE,6BAAA;AA7FR;AAmGI;EACE,uCAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAjGN;AAoGI;EACE,uCAAA;AAlGN;;AAuGA;EAGM;IACE,iBAAA;EAtGN;AACF;AA2GA;EAGM;IACE,iBAAA;EA3GN;AACF","sourcesContent":[".concept-list {\n  padding: 0;\n  background-color: #ffffff;\n  min-height: 100vh;\n\n  @media (max-width: 1200px) {\n    padding: 24px 0;\n  }\n\n  .sectionTitle {\n    font-size: 48px;\n    color: #2c3e50;\n    margin-bottom: 24px;\n    text-align: center;\n    font-weight: 800;\n    letter-spacing: -1px;\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);\n\n    @media (max-width: 1200px) {\n      font-size: 36px;\n    }\n  }\n\n  .sectionDescription {\n    font-size: 20px;\n    color: #34495e;\n    max-width: 800px;\n    margin: 0 auto 48px;\n    text-align: center;\n    line-height: 1.6;\n\n    @media (max-width: 1200px) {\n      font-size: 18px;\n      margin-bottom: 36px;\n    }\n  }\n\n  .featuredSectionWrapper {\n    width: 100%;\n    margin: 64px 0 80px;\n    background-color: transparent;\n\n    @media (max-width: 1200px) {\n      margin: 32px 0 64px;\n    }\n  }\n\n  .featuredSection {\n    width: 100%;\n    max-width: none;\n    position: relative;\n    overflow: visible;\n\n    @media (max-width: 1200px) {\n      padding: 0 16px;\n    }\n  }\n\n  .conceptTabs {\n    position: relative;\n    z-index: 1;\n    margin-bottom: 24px;\n\n    :global(.ant-tabs-nav) {\n      &::before {\n        display: none;\n      }\n    }\n\n    :global(.ant-tabs-nav-list) {\n      background: transparent;\n      border-radius: 0;\n      padding: 0;\n      display: flex;\n      justify-content: center;\n    }\n\n    :global(.ant-tabs-tab) {\n      font-size: 16px;\n      padding: 8px 16px;\n      transition: all 0.3s ease;\n      border-radius: 4px;\n      margin: 0 8px;\n      background: transparent;\n      border: none;\n      color: rgba(0, 0, 0, 0.65);\n\n      .anticon,\n      svg {\n        margin-right: 8px;\n        vertical-align: middle;\n      }\n    }\n\n    :global(.ant-tabs-tab-active) {\n      font-weight: 600;\n      background: transparent;\n      box-shadow: none;\n\n      &::after {\n        content: \"\";\n        position: absolute;\n        bottom: 0;\n        left: 50%;\n        transform: translateX(-50%);\n        width: 20px;\n        height: 2px;\n      }\n    }\n\n    :global(.ant-tabs-ink-bar) {\n      display: none;\n    }\n  }\n\n  .carouselWrapper {\n    margin: 20px -24px;\n    padding: 20px 0 80px;\n    position: relative;\n    will-change: transform;\n\n    @media (max-width: 1200px) {\n      margin: 30px -16px;\n      padding: 20px 40px 0;\n    }\n\n    :global {\n      .ant-carousel {\n        margin-bottom: 20px;\n\n        .slick-slider {\n          .slick-list {\n            @media (max-width: 2560px) {\n              height: 550px;\n            }\n\n            @media only screen and (max-width: 1200px) {\n              height: 550px;\n            }\n          }\n        }\n\n        .slick-slide {\n          padding: 0 10px;\n          opacity: 0.5;\n          transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1),\n            transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n          will-change: opacity, transform;\n\n          &.slick-active {\n            opacity: 1;\n\n            &.slick-current {\n              transform: scale(1.05);\n            }\n          }\n        }\n\n        .slick-dots {\n          bottom: -40px;\n\n          li {\n            button {\n              background-color: rgba(52, 152, 219, 0.3);\n            }\n\n            &.slick-active button {\n              background: linear-gradient(\n                90deg,\n                rgba(142, 68, 173, 0.8),\n                rgba(52, 152, 219, 0.8)\n              );\n            }\n          }\n        }\n\n        .slick-prev,\n        .slick-next {\n          z-index: 1;\n          width: 40px;\n          height: 40px;\n          background: linear-gradient(\n            135deg,\n            rgba(142, 68, 173, 0.1),\n            rgba(52, 152, 219, 0.1)\n          );\n          border-radius: 50%;\n          transition: all 0.3s ease;\n          opacity: 0.7;\n\n          &:hover,\n          &:focus {\n            background: linear-gradient(\n              135deg,\n              rgba(142, 68, 173, 0.2),\n              rgba(52, 152, 219, 0.2)\n            );\n            opacity: 1;\n          }\n\n          &::before {\n            content: \"\";\n            width: 10px;\n            height: 10px;\n            border-top: 2px solid rgba(52, 152, 219, 0.8);\n            border-right: 2px solid rgba(52, 152, 219, 0.8);\n            display: block;\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transition: all 0.3s ease;\n            color: transparent;\n            font-size: 0;\n            line-height: 0;\n          }\n\n          &::after {\n            display: none;\n          }\n\n          &:hover::before {\n            border-top: 2px solid rgba(142, 68, 173, 0.8);\n            border-right: 2px solid rgba(142, 68, 173, 0.8);\n          }\n        }\n\n        .slick-prev {\n          left: -5px;\n          &::before {\n            transform: translate(-25%, -50%) rotate(-135deg);\n          }\n        }\n\n        .slick-next {\n          right: -5px;\n          &::before {\n            transform: translate(-75%, -50%) rotate(45deg);\n          }\n        }\n      }\n    }\n  }\n\n  .carouselSlide {\n    height: 100%;\n    padding: 20px 0;\n    will-change: transform;\n  }\n\n  .carouselItem {\n    background: linear-gradient(135deg, #fafbff 0%, #f8f9ff 100%);\n    border-radius: 16px;\n    overflow: hidden;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);\n    min-height: 350px;\n    max-height: 500px;\n    display: flex;\n    flex-direction: column;\n    padding: 20px;\n    max-width: 95%;\n    margin: 0 auto;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    will-change: transform, box-shadow;\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    position: relative;\n    z-index: 1;\n\n    @media (max-width: 1200px) {\n      padding: 16px;\n    }\n\n    .ant-card {\n      &:hover {\n        transform: translateY(-5px);\n        box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);\n\n        &::before {\n          opacity: 1;\n        }\n      }\n    }\n\n    .cardContent {\n      display: flex;\n      flex-direction: column;\n      height: 100%;\n    }\n\n    .header {\n      margin-bottom: 16px;\n      position: relative;\n      padding-bottom: 16px;\n      text-align: center;\n\n      &::after {\n        content: \"\";\n        position: absolute;\n        bottom: 0;\n        left: 50%;\n        transform: translateX(-50%);\n        width: 40px;\n        height: 3px;\n        background: linear-gradient(90deg, #8e44ad 0%, #3498db 100%);\n        border-radius: 2px;\n      }\n\n      @media (max-width: 1200px) {\n        margin-bottom: 12px;\n        padding-bottom: 12px;\n      }\n    }\n\n    .title {\n      font-size: 24px;\n      font-weight: 700;\n      background: linear-gradient(90deg, #8e44ad 0%, #3498db 100%);\n      -webkit-background-clip: text;\n      background-clip: text;\n      -webkit-text-fill-color: transparent;\n      text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);\n      margin-bottom: 8px;\n\n      @media (max-width: 1200px) {\n        font-size: 20px;\n      }\n    }\n\n    .conceptDefinition {\n      margin-bottom: 16px;\n      font-size: 14px;\n      line-height: 1.4;\n      color: #34495e;\n      text-align: left;\n      max-height: 60px;\n      overflow: hidden;\n\n      @media (max-width: 1200px) {\n        font-size: 12px;\n        margin-bottom: 12px;\n      }\n    }\n\n    .chartWrapper {\n      flex-grow: 1;\n      min-height: 120px;\n      margin-top: 16px;\n      margin-bottom: 16px;\n      width: 100%;\n\n      @media (max-width: 1200px) {\n        min-height: 100px;\n        margin-top: 12px;\n        margin-bottom: 12px;\n      }\n\n      @media (min-width: 768px) and (max-width: 1199px) {\n        min-height: 150px;\n      }\n\n      .customTooltip {\n        background-color: rgba(255, 255, 255, 0.9);\n        border: 1px solid #ccc;\n        padding: 10px;\n        border-radius: 4px;\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n\n        .label {\n          font-weight: bold;\n          margin-bottom: 5px;\n        }\n\n        .data {\n          margin: 0;\n          font-size: 12px;\n        }\n      }\n\n      :global(.recharts-legend-wrapper) {\n        font-size: 12px;\n\n        .recharts-legend-item {\n          padding-right: 10px;\n        }\n      }\n    }\n\n    .conceptStats {\n      margin-bottom: 16px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n\n      @media (max-width: 1200px) {\n        margin-bottom: 12px;\n      }\n\n      .statWrapper {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        position: relative;\n        padding: 0 16px;\n\n        .statContent {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          margin-bottom: 8px;\n        }\n\n        svg {\n          color: inherit;\n          margin-right: 8px;\n        }\n\n        .statValue {\n          font-size: 18px;\n          color: inherit;\n\n          @media only screen and (max-width: 480px) {\n            font-size: 14px;\n          }\n        }\n\n        .statTitle {\n          position: absolute;\n          top: 100%;\n          left: 50%;\n          transform: translateX(-50%);\n          background-color: rgba(52, 152, 219, 0.9);\n          color: white;\n          padding: 4px 8px;\n          border-radius: 4px;\n          font-size: 14px;\n          opacity: 0;\n          transition: opacity 0.3s ease;\n          white-space: nowrap;\n          pointer-events: none;\n        }\n\n        &:hover .statTitle {\n          opacity: 1;\n        }\n      }\n    }\n\n    .cardFooter {\n      margin-top: 16px;\n      text-align: right;\n    }\n\n    .viewMoreButton {\n      background: transparent;\n      color: #3498db;\n      padding: 8px 0;\n      font-size: 16px;\n      font-weight: 500;\n      transition: all 0.3s ease;\n      border: none;\n      text-decoration: none;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n\n      &:hover {\n        color: #2980b9;\n        text-decoration: underline;\n      }\n\n      .lucide {\n        margin-left: 8px;\n        transition: transform 0.3s ease;\n      }\n\n      &:hover .lucide {\n        transform: translateX(2px);\n      }\n\n      @media (max-width: 1200px) {\n        font-size: 14px;\n      }\n    }\n  }\n\n  .explorationSection {\n    background-color: #ffffff;\n    padding: 0 0 40px;\n    position: relative;\n    overflow: hidden;\n\n    @media (max-width: 1200px) {\n      padding: 0 0 30px;\n    }\n\n    .explorationContent {\n      max-width: 1200px;\n      margin: 0 auto;\n      padding: 0 32px;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n\n      @media (max-width: 1200px) {\n        padding: 0 24px;\n      }\n    }\n\n    .sectionTitle {\n      font-size: 40px;\n      color: #2c3e50;\n      margin-bottom: 12px;\n      text-align: center;\n      font-weight: 800;\n      letter-spacing: -1px;\n      text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);\n\n      @media (max-width: 1200px) {\n        font-size: 32px;\n      }\n    }\n\n    .sectionDescription {\n      font-size: 18px;\n      color: #34495e;\n      max-width: 800px;\n      margin: 0 auto 32px;\n      text-align: center;\n      line-height: 1.6;\n\n      @media (max-width: 1200px) {\n        font-size: 16px;\n        margin-bottom: 24px;\n      }\n    }\n\n    .searchSection {\n      width: 100%;\n      max-width: 800px;\n      margin: 0 auto;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n\n      @media (max-width: 1200px) {\n        margin-bottom: 24px;\n      }\n    }\n\n    .searchWrapper {\n      width: 100%;\n      margin-bottom: 24px;\n\n      :global(.ant-input-affix-wrapper) {\n        width: 100%;\n        border-radius: 8px;\n        border: 2px solid #e8e8e8;\n        transition: all 0.3s ease;\n        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n\n        &:hover,\n        &:focus-within {\n          border-color: #3498db;\n          box-shadow: 0 6px 12px rgba(52, 152, 219, 0.2);\n        }\n\n        input {\n          font-size: 16px;\n          padding: 12px 16px;\n        }\n      }\n\n      :global(.ant-input-prefix),\n      :global(.ant-input-suffix) {\n        color: #3498db;\n      }\n    }\n\n    .searchHint {\n      font-size: 14px;\n      color: #7f8c8d;\n      text-align: center;\n      font-style: italic;\n      margin-bottom: 12px;\n    }\n\n    .filterTags {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: center;\n      width: 100%;\n      margin-bottom: 24px;\n\n      .queryTag {\n        background-color: rgba(204, 0, 88, 0.1);\n        border: 1px solid rgba(255, 84, 156, 0.3);\n        color: rgb(204, 0, 88);\n        font-size: 14px;\n        padding: 6px 12px;\n        margin: 4px;\n        display: flex;\n        align-items: center;\n        transition: all 0.3s;\n        border-radius: 8px;\n        box-shadow: 0 2px 4px rgba(204, 0, 88, 0.1);\n\n        &:hover {\n          background-color: rgba(204, 0, 88, 0.2);\n          box-shadow: 0 4px 8px rgba(204, 0, 88, 0.15);\n        }\n\n        :global(.anticon) {\n          color: rgb(204, 0, 88);\n          font-size: 12px;\n          margin-left: 6px;\n          cursor: pointer;\n          transition: all 0.3s;\n\n          &:hover {\n            color: rgb(255, 84, 156);\n          }\n        }\n      }\n    }\n\n    .conceptGrid {\n      width: 100%;\n      margin-top: 24px;\n    }\n\n    .paginationWrapper {\n      margin-top: 32px;\n      display: flex;\n      justify-content: center;\n    }\n  }\n\n  .sectionDivider {\n    margin: 0 auto 80px;\n    width: 80%;\n    max-width: 1200px;\n    border: none;\n    height: 2px;\n    background-image: linear-gradient(\n      to right,\n      transparent,\n      rgba(142, 68, 173, 0.2),\n      rgba(52, 152, 219, 0.2),\n      rgba(204, 0, 88, 0.2),\n      rgba(255, 84, 156, 0.2),\n      transparent\n    );\n    position: relative;\n    overflow: visible;\n  }\n\n  .floatButtonGroup {\n    :global {\n      .ant-float-btn-group {\n        width: 60px;\n        height: 60px;\n        .ant-float-btn {\n          background-color: #ffffff;\n          border: 1px solid rgba(204, 0, 88, 0.2);\n          box-shadow: 0 2px 8px rgba(204, 0, 88, 0.15);\n          transition: all 0.3s;\n\n          &:hover {\n            background-color: rgba(204, 0, 88, 0.1);\n            transform: translateY(-2px);\n          }\n\n          .ant-float-btn-body {\n            width: 100%;\n            height: 100%;\n            background-color: transparent;\n            border: none;\n            box-shadow: none;\n\n            .ant-float-btn-content {\n              width: 100%;\n              height: 100%;\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              color: rgb(204, 0, 88);\n            }\n          }\n        }\n      }\n\n      :global(.ant-float-btn-default) {\n        background-color: #ffffff;\n\n        .ant-float-btn-body {\n          background-color: transparent;\n\n          .ant-float-btn-content {\n            color: rgb(204, 0, 88);\n          }\n        }\n\n        &:hover {\n          background-color: rgba(204, 0, 88, 0.1);\n        }\n      }\n    }\n\n    :global(.ant-float-btn-icon) {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    .floatButton {\n      margin-bottom: 16px;\n      margin-right: 16px;\n      transition: all 0.3s;\n\n      &:hover {\n        transform: scale(1.1);\n      }\n\n      :global(.ant-float-btn-body) {\n        background-color: transparent;\n      }\n    }\n  }\n\n  :global(.ant-tooltip) {\n    .ant-tooltip-inner {\n      background-color: rgba(204, 0, 88, 0.9);\n      color: #ffffff;\n      font-size: 14px;\n      padding: 6px 12px;\n      border-radius: 4px;\n    }\n\n    .ant-tooltip-arrow-content {\n      background-color: rgba(204, 0, 88, 0.9);\n    }\n  }\n}\n\n@media (min-width: 1600px) {\n  .concept-list {\n    .explorationSection {\n      .explorationContent {\n        max-width: 1800px;\n      }\n    }\n  }\n}\n\n@media (min-width: 2560px) {\n  .concept-list {\n    .explorationSection {\n      .explorationContent {\n        max-width: 2400px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"concept-list": `ConceptList_concept-list__TQIxW`,
	"sectionTitle": `ConceptList_sectionTitle__hjSiV`,
	"sectionDescription": `ConceptList_sectionDescription__uTd0d`,
	"featuredSectionWrapper": `ConceptList_featuredSectionWrapper__GRdA2`,
	"featuredSection": `ConceptList_featuredSection__0JL9w`,
	"conceptTabs": `ConceptList_conceptTabs__hzMHJ`,
	"anticon": `ConceptList_anticon__AvnaU`,
	"carouselWrapper": `ConceptList_carouselWrapper__VKlKS`,
	"carouselSlide": `ConceptList_carouselSlide__psVEW`,
	"carouselItem": `ConceptList_carouselItem__Lopn6`,
	"ant-card": `ConceptList_ant-card__kDN5n`,
	"cardContent": `ConceptList_cardContent__UQNGt`,
	"header": `ConceptList_header__0BWqy`,
	"title": `ConceptList_title__vhXhx`,
	"conceptDefinition": `ConceptList_conceptDefinition__aVrPK`,
	"chartWrapper": `ConceptList_chartWrapper__FMkrX`,
	"customTooltip": `ConceptList_customTooltip__jNYFa`,
	"label": `ConceptList_label__e1qDF`,
	"data": `ConceptList_data__3I+Rd`,
	"recharts-legend-item": `ConceptList_recharts-legend-item__zG5n4`,
	"conceptStats": `ConceptList_conceptStats__fU12B`,
	"statWrapper": `ConceptList_statWrapper__p57Vh`,
	"statContent": `ConceptList_statContent__mEqHM`,
	"statValue": `ConceptList_statValue__QvLM5`,
	"statTitle": `ConceptList_statTitle__KC4bL`,
	"cardFooter": `ConceptList_cardFooter__RtQ5Q`,
	"viewMoreButton": `ConceptList_viewMoreButton__bxHur`,
	"lucide": `ConceptList_lucide__GcDI9`,
	"explorationSection": `ConceptList_explorationSection__ucnoj`,
	"explorationContent": `ConceptList_explorationContent__aoH+V`,
	"searchSection": `ConceptList_searchSection__sCQ72`,
	"searchWrapper": `ConceptList_searchWrapper__iv8Y9`,
	"searchHint": `ConceptList_searchHint__vnvkB`,
	"filterTags": `ConceptList_filterTags__kqam5`,
	"queryTag": `ConceptList_queryTag__rH3rg`,
	"conceptGrid": `ConceptList_conceptGrid__yhhSW`,
	"paginationWrapper": `ConceptList_paginationWrapper__vYVjy`,
	"sectionDivider": `ConceptList_sectionDivider__LxVcv`,
	"floatButtonGroup": `ConceptList_floatButtonGroup__UvyOa`,
	"floatButton": `ConceptList_floatButton__JuyOF`,
	"ant-tooltip-inner": `ConceptList_ant-tooltip-inner__I67S3`,
	"ant-tooltip-arrow-content": `ConceptList_ant-tooltip-arrow-content__VT5sz`
};
export default ___CSS_LOADER_EXPORT___;
